import React, { useEffect } from 'react'

const PrivacyPolicy = () => {
    useEffect(() =>{
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth'})
    },[])
  return (
    <div className='d-flex justify-content-center align-items-center mt-2'>
      <div className='privacy_page'>
        <h1 className='d-flex justify-content-center align-items-center'>Privacy Policy</h1>
        <p>
          At Nexonweb Solution, we respect your privacy and are committed to protecting the personal information you share with us. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information in accordance with applicable laws, including the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, hereinafter referred to as "Indian Data Protection Law."
        </p>
        <p>
        By using our services, you agree to the practices outlined in this Privacy Policy. If you do not agree, please refrain from using our services.
        </p>
        <h5 className='fw-bold'>1.Collection of Personal Data</h5>
        <p>We only collect personal data when necessary for the technical, legal, and commercial operations of our services. The data we collect includes but is not limited to:</p>
        <div className='d-flex flex-column gap-1 mt-4'> 
            <span>Name</span>
            <span>Contact information (email address, phone number)</span>
            <span>Billing and delivery addresses</span>
            <span>Payment information (processed via secure third-party gateways)</span>
            <span>Usage data such as IP address, browser details, and access times</span>
            <span>Key Principles of Data Collection:</span>
            <span>Transparency: Users will be informed at the time of collection about the specific purpose of data collection</span>
            <span>Fair Use: Data will only be used for the stated purpose(s) and in a lawful manner.</span>
            <span>Minimal Collection: Only necessary information will be collected for providing the requested services.</span>
        </div>

        <h5 className='fw-bold mt-4'>2.Use of Personal Data</h5>
        <p>All data collected will be used for the following purposes:</p>
        <div className='d-flex flex-column gap-1 mt-4'>
            <span>Fulfilling service requests and improving the quality of services.</span>
            <span>Responding to user inquiries or providing customer support.</span>
            <span>Sending transactional updates, newsletters, and promotional materials (with prior consent).</span>
            <span>Complying with legal obligations and resolving disputes.</span>
            <span>Your data will not be used for any other purpose without your explicit consent.</span>
        </div>

        <h5 className='fw-bold mt-4'>3.User Rights</h5>
        <p>We are committed to ensuring that users retain control over their personal data. You have the right to:</p>
        <div className='d-flex flex-column gap-1 mt-4'>
             <span>Access: View the personal data we hold about you.</span>
             <span>Rectification: Request corrections to any inaccurate or outdated information.</span>
             <span>Deletion: Request deletion of your personal data, subject to applicable legal and operational constraints.</span>
             <span>Withdraw Consent: Revoke consent for data processing at any time.</span>
             <span>To exercise these rights, contact us at [insert contact email or form link].</span>
        </div>

        <h5 className='fw-bold mt-4'>4.Security of Personal Data</h5>
        <p>We employ both technical and organizational measures to protect your personal data, including:</p>
        <div className='d-flex flex-column gap-1 mt-4'>
            <span>Encrypted storage of sensitive information.</span>
            <span>Restricted access to databases and secure servers.</span>
            <span>Periodic security audits and updates to ensure data safety.</span>
            <span>While we take every precaution, we do not guarantee that unauthorized access, loss, or misuse of data will never occur.</span>
        </div>

        <h5 className='fw-bold mt-4'>5.Use of Cookies</h5>
        <p>To enhance user experience and improve our website, we use cookies. Cookies allow us to:</p>
        <div className='d-flex flex-column gap-1 mt-4'>
            <span>Track user activity to understand preferences and optimize services.</span>
            <span>Analyze website performance and usage statistics.</span>
            <span>You may disable cookies in your browser settings, but this may limit your ability to use certain features of our website.</span>
        </div>

        <h5 className='fw-bold mt-4'>6.Disclosure of Personal Data</h5>
        <p>We will not share your personal data with third parties unless:</p>
        <div className='d-flex flex-column gap-1 mt-4'>
             <span>We are legally obligated to do so.</span>
             <span>You have explicitly authorized us to share your data.</span>
             <span>No Sale of Data: We do not sell user data to third parties.</span>
        </div>
        <div className='d-flex flex-column gap-1 mt-4'>
            <span>We may disclose information to comply with legal processes, enforce our Terms of Service, or protect the rights, property, or safety of our users.</span>
        </div>

        <h5 className='fw-bold mt-4'>7.Retention of Personal Data</h5>
        <p>Your personal data will be stored only as long as necessary to fulfill the purpose for which it was collected or to comply with applicable legal obligations. Once the purpose is fulfilled or the retention period lapses, your data will be securely deleted.</p>

        <h5 className='fw-bold mt-4'>8.Third-Party Services</h5>
        <p>Nexonweb Solution may use third-party services to process payments, analyze usage data, or provide additional services. These third parties are contractually obligated to handle your data securely and only for the purpose of providing the requested service.</p>

        <h5 className='fw-bold mt-4'>9.Changes to this Privacy Policy</h5>
        <p>We reserve the right to update this Privacy Policy to reflect changes in legal or operational requirements. Users will be notified of significant changes through email or an update on our website.</p>


        <h5 className='fw-bold mt-4'>10.Grievance Redressal</h5>
        <div className='d-flex flex-column mt-3 gap-3'>
            <span>If you have any concerns or grievances regarding the collection, use, or handling of your personal data, please contact our Data Protection Help email at: info@nexonweb.com</span>
            <span>We are committed to addressing your concerns in a timely and efficient manner, in compliance with Indian Data Protection Law.</span>
            <span>By using Nexonweb Solution’s services, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.</span>
            <div className='d-flex flex-column'>
                <span>Contact Us</span>
                <span>For any questions about this Privacy Policy or how we handle your data, contact us at:</span>
            </div>
            <div className='d-flex flex-column'>
                <span>Email: info@nexonweb.com</span>
                <span>Phone: +91-9063630795</span>
            </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy
